export const INITIAL_ARRAY_INDEX = 0;

export const MAX_BANK_NAME_LENGTH = 50;

export const limits = {
  ANOTHER_BANK_COUNT: 5
};
export const ANNUAL_TURNOVER_MAX_LENGTH = 16;
export const COMPANY_CURRENCY = "AED";
export const PLACEHOLDER = "9999999999";
export const BASED_IN_UAE = "UAE";
export const BASED_IN_NONUAE = "NON-UAE";

export const initialoutSideUAE = [
  {
    bankName: "",
    IBAN: "",
    currency: "",
    loanExists: false,
    loanType: "",
    loanAmount: "",
    loanCurrency: ""
  }
];

export const initialBankLoan = [
  {
    // otherBankLoanExist: false,
    basedIn: "",
    bankName: "",
    // IBAN: "",
    iban: "",
    currency: "",
    loanFacility: ""
  }
];

export const SPLIT_OPTIONS = [{ value: -50, label: "50 %" }, { value: 50, label: "50 %" }];
